import { useEffect, useRef, useState } from 'react'

function Instagram() {
  const scrollWrapperRef = useRef(null)
  const [canScrollLeft, setCanScrollLeft] = useState(false)
  const [canScrollRight, setCanScrollRight] = useState(true)

  const images = [
    {
      url: '/assets/images/lifestyle/instagram/insta1.jpg',
      link: 'https://www.instagram.com/bijouterie.r.j/reel/DC4D5QAJplp/',
    },
    {
      url: '/assets/images/lifestyle/instagram/insta3.jpg',
      link: 'https://www.instagram.com/p/DEKZFx9RYx1/',
    },
    {
      url: '/assets/images/lifestyle/instagram/insta2.jpg',
      link: 'https://www.instagram.com/p/DCULL5xp5-f/',
    },
    {
      url: '/assets/images/lifestyle/instagram/insta4.jpg',
      link: 'https://www.instagram.com/p/DCb1c3BJAxG/',
    },
    {
      url: '/assets/images/lifestyle/instagram/insta5.jpg',
      link: 'https://www.instagram.com/p/DDYPkLNJTlE/',
    },
    {
      url: '/assets/images/lifestyle/instagram/insta6.jpg',
      link: 'https://www.instagram.com/p/C9zlKY5JLjU/',
    },
    {
      url: '/assets/images/lifestyle/instagram/insta8.jpg',
      link: 'https://www.instagram.com/p/DC9zemNp9Ng/',
    },
    {
      url: '/assets/images/lifestyle/instagram/insta9.jpg',
      link: 'https://www.instagram.com/p/DEI9X5ZJSGv/',
    },
    {
      url: '/assets/images/lifestyle/instagram/insta10.jpg',
      link: 'https://www.instagram.com/p/DBMGTADpM7A/?img_index=1',
    },
    {
      url: '/assets/images/lifestyle/instagram/insta11.jpg',
      link: 'https://www.instagram.com/p/DABVGqLpsq2/',
    },
  ]

  // Check scroll position to enable/disable navigation buttons
  const checkScrollButtons = () => {
    const wrapper = scrollWrapperRef.current
    if (!wrapper) return

    setCanScrollLeft(wrapper.scrollLeft > 0)
    setCanScrollRight(wrapper.scrollLeft < wrapper.scrollWidth - wrapper.clientWidth)
  }

  // Scroll navigation functions
  const scrollLeft = () => {
    const wrapper = scrollWrapperRef.current
    if (!wrapper) return

    const cardWidth = 320 // card width + gap
    wrapper.scrollBy({ left: -cardWidth, behavior: 'smooth' })
  }

  const scrollRight = () => {
    const wrapper = scrollWrapperRef.current
    if (!wrapper) return

    const cardWidth = 320 // card width + gap
    wrapper.scrollBy({ left: cardWidth, behavior: 'smooth' })
  }

  // Enhanced touch handling for mobile scrolling and scroll button updates
  useEffect(() => {
    const wrapper = scrollWrapperRef.current
    if (!wrapper) return

    // Initial check
    checkScrollButtons()

    let isScrolling = false
    let startX = 0
    let scrollLeftPos = 0

    const handleTouchStart = (e) => {
      isScrolling = true
      startX = e.touches[0].pageX - wrapper.offsetLeft
      scrollLeftPos = wrapper.scrollLeft
    }

    const handleTouchMove = (e) => {
      if (!isScrolling) return
      e.preventDefault()

      const x = e.touches[0].pageX - wrapper.offsetLeft
      const walk = (x - startX) * 2
      wrapper.scrollLeft = scrollLeftPos - walk
    }

    const handleTouchEnd = () => {
      isScrolling = false
      checkScrollButtons()
    }

    const handleScroll = () => {
      checkScrollButtons()
    }

    // Add event listeners
    wrapper.addEventListener('touchstart', handleTouchStart, { passive: false })
    wrapper.addEventListener('touchmove', handleTouchMove, { passive: false })
    wrapper.addEventListener('touchend', handleTouchEnd, { passive: true })
    wrapper.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      wrapper.removeEventListener('touchstart', handleTouchStart)
      wrapper.removeEventListener('touchmove', handleTouchMove)
      wrapper.removeEventListener('touchend', handleTouchEnd)
      wrapper.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <section className="tc-instagram-style6">
      <div className="container">
        <div className="instagram-header">
          <div className="header-content">
            <div className="profile-picture">
              <img
                src="/assets/images/lifestyle/instagram/ig_profile.jpg"
                alt="Bijouterie R.J Instagram Profile"
              />
            </div>
            <div className="header-text">
              <h3 className="marcellus">Follow us on Instagram</h3>
              <a
                href="https://www.instagram.com/bijouterie.r.j/"
                target="_blank"
                rel="noopener noreferrer"
                className="subtitle-link"
              >
                @bijouterie.r.j
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="instagram-slider-container">
        <button
          className={`nav-arrow nav-arrow-left ${!canScrollLeft ? 'disabled' : ''}`}
          onClick={scrollLeft}
          disabled={!canScrollLeft}
          aria-label="Scroll left"
        >
          <i className="fas fa-chevron-left"></i>
        </button>

        <button
          className={`nav-arrow nav-arrow-right ${!canScrollRight ? 'disabled' : ''}`}
          onClick={scrollRight}
          disabled={!canScrollRight}
          aria-label="Scroll right"
        >
          <i className="fas fa-chevron-right"></i>
        </button>

        <div ref={scrollWrapperRef} className="instagram-scroll-wrapper">
          {images.map(({ url, link }, index) => (
            <a
              href={link}
              className="insta-card"
              key={index}
              target="_blank"
              rel="noopener noreferrer"
              onTouchStart={(e) => {
                if (e.currentTarget) {
                  e.currentTarget.classList.add('touch-active')
                }
              }}
              onTouchEnd={(e) => {
                const target = e.currentTarget
                if (target) {
                  setTimeout(() => {
                    target.classList.remove('touch-active')
                  }, 150)
                }
              }}
            >
              <div className="img h-same-w">
                <img src={url} alt={`Instagram post ${index + 1}`} className="img-cover" />
              </div>
              <span className="icon">
                <i className="fab fa-instagram"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Instagram
